package br.com.texeratx.boardgametimeapp.ui.screens.expansions.list

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import br.com.texeratx.boardgametimeapp.ui.screens.expansions.create.CreateExpansionScreen
import br.com.texeratx.boardgametimeapp.ui.screens.expansions.edit.EditExpansionScreen
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.koinInject

class ExpansionsScreen : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val viewModel = koinInject<ExpansionsViewModel>()
        val state by viewModel.state.collectAsState()

        LaunchedEffect(Unit) { viewModel.load() }

        ExpansionsUI(
            state = state,
            onBack = { navigator.pop() },
            onCreate = { navigator.push(CreateExpansionScreen()) },
            onEdit = { expansionId ->

                navigator.push(EditExpansionScreen(expansionId))

            }
        )
    }
}
